export default __webpack_public_path__ + "img/carling.be25aa13.jpg";